import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleEyesYeux11 = customSolarIconWrapper(<g transform="translate(88 112.5)">
	<path d="M50.2998 0L54.1998 9.1L63.2998 13L54.1998 16.9L50.2998 26L46.3998 16.9L37.2998 13L46.3998 9.1L50.2998 0Z" fill="#202020" />
	<path d="M13 4.09998L16.9 13.2L26 17.1L16.9 21L13 30.1L9.1 21L0 17.1L9.1 13.2L13 4.09998Z" fill="#202020" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleEyesYeux11;
